import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { GlimpseFeedbackAdmin } from "@/components/admin/GlimpseFeedbackAdmin";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });
const COLS = [
  ["started", "Started"], ["finished", "Finished"], ["continued", "Continued to full"], ["completed_full", "Completed full Portrait"],
  ["instagram", "Glimpse: Instagram taps"], ["linkedin", "Glimpse: LinkedIn taps"],
  ["portrait_instagram", "Full Portrait: Instagram taps"], ["portrait_linkedin", "Full Portrait: LinkedIn taps"],
];

const Stat = ({ label, value, sub, testId }) => (
  <div className="cg-card p-5" data-testid={testId}>
    <p className="cg-eyebrow">{label}</p>
    <p className="font-serif text-4xl text-[#F3F4F6] mt-2">{value}</p>
    {sub && <p className="text-xs text-[#6B7280] mt-1">{sub}</p>}
  </div>
);

export const GlimpseStats = () => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/glimpse/admin/weekly-stats?weeks=12").then((r) => setData(r.data))
      .catch((e) => setErr(formatApiError(e.response?.data?.detail) || e.message));
  }, []);
  if (err) return <p className="text-terracotta text-sm" data-testid="glimpse-stats-error">{err}</p>;
  if (!data) return <p className="cg-eyebrow animate-pulse">Loading…</p>;
  const t = data.totals;
  return (
    <div className="space-y-6" data-testid="glimpse-stats">
      <div>
        <h2 className="font-serif text-3xl text-[#F3F4F6]">Authority Glimpse</h2>
        <p className="text-sm text-[#9CA3AF] mt-1">Counts of people, by the week each step happened (Monday–Sunday, Toronto time). Test and demo accounts are excluded ({data.excluded_test_accounts} hidden).</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat testId="glimpse-total-started" label="Started (all time)" value={t.started} />
        <Stat testId="glimpse-total-finished" label="Finished" value={t.finished} sub={data.finish_rate != null ? `${data.finish_rate}% of those who started` : null} />
        <Stat testId="glimpse-total-continued" label="Continued to full" value={t.continued} sub={data.continue_rate != null ? `${data.continue_rate}% of those who finished` : null} />
        <Stat testId="glimpse-total-completed-full" label="Completed full Portrait" value={t.completed_full} />
        <Stat testId="glimpse-total-instagram" label="Tapped Instagram share" value={t.instagram} sub="people, all time" />
        <Stat testId="glimpse-total-linkedin" label="Tapped LinkedIn share" value={t.linkedin} sub="people, all time" />
        <Stat testId="portrait-total-instagram" label="Full Portrait: Instagram taps" value={t.portrait_instagram} sub="people, all time · pop-up" />
        <Stat testId="portrait-total-linkedin" label="Full Portrait: LinkedIn taps" value={t.portrait_linkedin} sub="people, all time · pop-up" />
      </div>
      <div className="cg-card p-6 overflow-x-auto">
        <p className="cg-eyebrow mb-3">Last 12 weeks</p>
        <table className="w-full text-sm" data-testid="glimpse-weekly-table">
          <thead><tr className="text-left text-[#9CA3AF] border-b border-[var(--cg-border)]">
            <th className="py-2 pr-4 font-normal">Week</th>
            {COLS.map(([k, l]) => <th key={k} className="py-2 px-3 font-normal text-right">{l}</th>)}
          </tr></thead>
          <tbody>
            {data.weeks.map((w, i) => (
              <tr key={w.week_start} className="border-b border-[var(--cg-border)] last:border-0" data-testid={`glimpse-week-${w.week_start}`}>
                <td className="py-2.5 pr-4 text-[#E8EAEE] whitespace-nowrap">{fmt(w.week_start)} – {fmt(w.week_end)}{i === 0 && <span className="text-xs text-[#6B7280]"> · this week</span>}</td>
                {COLS.map(([k]) => <td key={k} className={`py-2.5 px-3 text-right ${w[k] ? "text-[#F3F4F6]" : "text-[#4B5563]"}`}>{w[k]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-xs text-[#6B7280] mt-4">"Continued to full" counts people who began the paid 105-statement assessment with their 21 Glimpse answers carried over. Share columns count people who tapped the button (each person once per week); we can't see whether they finished posting. Glimpse columns include the Glimpse page and its pop-up; Full Portrait columns come from the pop-up on completed full Portraits.</p>
      </div>
      <GlimpseFeedbackAdmin />
    </div>
  );
};
